import {useQuery} from "@tanstack/react-query";
import {
    readDashboardSetting, readRevenueByHandlerByMonth,
    readRevenueByItem, readRevenueByTeamByMonth,
    readRevenueByTeamByQuarter, readRevenueByTeamByYear
} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

export const useReadRevenueByHandlerByMonth = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByHandlerByMonth"],
        queryFn: async () => await readRevenueByHandlerByMonth(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
